<script lang="ts">
  import clsx from 'clsx';
  import { getContext } from 'svelte';
  import { Cheese } from '@athena-lib/Icons';
  import { type UnorderedListContext, type ListItemProps, unorderedListContextKey } from './types';

  const { children, class: className }: ListItemProps = $props();
  const context = getContext<UnorderedListContext>(unorderedListContextKey);
  const itemNumber = ++context.renderedItems;
  const rotate = itemNumber % 2 === 0 ? 'rotate-[-40deg]' : 'rotate-[-70deg]';
</script>

<li class={clsx(className, 'flex justify-start py-2 pl-small')}>
  <div class={clsx('mr-4 mt-1 h-4 w-4 shrink-0', rotate)}>
    <Cheese />
  </div>
  <div>
    {@render children()}
  </div>
</li>
